import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api, unwrap, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { useI18n } from "@/i18n";

export default function PasswordChange() {
  const nav = useNavigate();
  const { user, loading, refresh, logout } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [saving, setSaving] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      const data = unwrap(await api.post("/me/change-password", form));
      localStorage.setItem("eduos_token", data.access_token);
      await refresh();
      toast.success("Password updated");
      nav("/", { replace: true });
    } catch (error) {
      toast.error(errMsg(error));
    } finally { setSaving(false); }
  };
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] px-6">
      <Card className="w-full max-w-md border-[var(--subtle)]" data-testid="password-change-page">
        <CardHeader><CardTitle className="font-display">{t("passwordChange.title")}</CardTitle><p className="text-sm text-[var(--text-secondary)]">{t("passwordChange.subtitle")}</p></CardHeader>
        <CardContent><form onSubmit={submit} className="space-y-4">
          <div><Label>{t("passwordChange.current")}</Label><Input type="password" autoComplete="current-password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="current-password" /></div>
          <div><Label>{t("passwordChange.new")}</Label><Input type="password" autoComplete="new-password" minLength={12} required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="new-password" /><p className="text-xs text-[var(--text-muted)] mt-1">{t("passwordChange.guidance")}</p></div>
          <div><Label>{t("passwordChange.confirm")}</Label><Input type="password" autoComplete="new-password" required value={form.confirm_password} onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} data-testid="confirm-password" /></div>
          <Button type="submit" disabled={saving} className="w-full bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white" data-testid="change-password-submit">{saving ? t("common.saving") : t("passwordChange.submit")}</Button>
          <Button type="button" variant="ghost" onClick={logout} className="w-full" data-testid="password-change-logout">{t("shell.logout")}</Button>
        </form></CardContent>
      </Card>
    </div>
  );
}
